import { Permission, WorkspacesListingItem } from '@futrli-sdk/workspaces';
import { withErrorBoundary, WithErrorBoundaryProps } from '@futrli/errors';
import { workspaceByIdSelector, getParamFromRoute, ROUTE_PARAMS } from '@futrli/shared-services';
import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { StoreState } from '../../core/redux-utils/types';
import { WorkspacesNavBar } from '../components/workspaces-navbar';

interface RouterProps {
  params: Record<string, string | undefined>;
}

interface StateToProps {
  readonly permissions: Permission[] | null;
}

type Props = StateToProps & RouterProps & WithErrorBoundaryProps;

class WorkspacesNavBarContainerBase extends React.PureComponent<Props> {
  public render(): JSX.Element {
    const { permissions } = this.props;
    return <WorkspacesNavBar permissions={permissions || undefined} />;
  }
}

const mapStateToProps = (state: StoreState, ownProps: RouterProps): StateToProps => {
  const workspaceId = getParamFromRoute(ownProps.params, ROUTE_PARAMS.WORKSPACE_ID) as string;
  const { normalised } = state;

  const currentWorkspace = workspaceByIdSelector(normalised, workspaceId) as WorkspacesListingItem;
  const storedPermissions = currentWorkspace ? currentWorkspace.permissions : null;

  return {
    permissions: storedPermissions
  };
};

export const WorkspacesNavBarContainerBaseWE = withErrorBoundary(WorkspacesNavBarContainerBase);
export const WorkspacesNavBarContainerWS = connect(mapStateToProps, {})(WorkspacesNavBarContainerBaseWE);

export const WorkspacesNavBarContainer: React.FC = () => {
  const params = useParams();
  return <WorkspacesNavBarContainerWS params={params} />;
};
